// extracted by mini-css-extract-plugin
module.exports = {"container":"FavoritesPage_container__DD_m-","controlsLabel":"FavoritesPage_controlsLabel__17qQ-"};